/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/candle_stick'
export default icon
